export const sportsImagesAssetsUrl: string = 'https://static-assets.lvbet.pl/images/';
